/* ============================================================
   Dental-Verlaengerung Starterkit (Stand 29.09.2026, Entscheidung
   Sales). MUSS nach theme.js UND gc-aposanitas.js geladen werden:
   legt sich um gcEnforceMengenrabatt(), genau wie gc-aposanitas.js.

   Worum es geht:
   Das Starterkit-Angebot (20 % auf Igloo + alle Testboxen ab
   1 Geraet + 5 Testboxen) endet fuer alle am 30.09.2026. Dental-
   Kund:innen bekommen es bis einschliesslich 15.10.2026. Danach
   gelten fuer alle wieder dieselben Konditionen (Startbonus).

   Wann ist ein Warenkorb "Dental"?
   Wenn das Warenkorb-Attribut dental_flow = true ist. Das setzt
   ausschliesslich ein Aufruf von /pages/dental (Kurzlink /dental),
   und nur solange die Aktion laeuft. Die Seite ist nicht im Menue
   verlinkt und nicht in Suchmaschinen (noindex + seo.hidden).

   Dann gilt, solange die Aktion laeuft:
   - ab Geraet + Mindestanzahl Testboxen: Code DENTALSTARTERKIT20
     (20 %, gleiche Collection und Mindestmenge wie STARTERKIT2026,
     in Shopify gueltig bis 15.10.2026, 23:59 Uhr). Der Code steht so im
     Checkout. Frueherer Code desselben Rabatts: STARTERKITDENTAL - wird
     entfernt, falls er noch in einem Warenkorb steht.
   - Der Vitamin-Dental-Partnercode VITAMINDENTAL und das Attribut
     "Partner: Vitamin Dental" werden entfernt: Kaeufe ueber die
     Dental-Seite gehoeren nicht zur Vitamin-Dental-Partnerschaft
     (Entscheidung Sales 29.09.2026).
   - STARTERKIT2026 wird dabei entfernt (nicht kombinierbar)
   - das Attribut startbonus_flow wird geloescht: kein 250-EUR-
     Gutschein zusaetzlich zum Dental-Starterkit-Rabatt
   - KEINE Umleitungen: /dental ist nur der "Schluessel". Danach kann
     man sich normal durch den ganzen Shop klicken (Entscheidung Sales
     29.09.2026); der Dental-Rabatt haengt am Warenkorb, nicht an der
     Seite, auf der bestellt wird.
   - Wird der Warenkorb geleert (letzte Position entfernt oder
     "Warenkorb leeren"), endet der Dental-Modus: dental_flow und
     Kundengruppe werden geloescht. Wer weiter Dental einkaufen will,
     steigt wieder ueber /dental ein. "Rueckgaengig" nach dem Leeren
     stellt den Dental-Modus mit dem Warenkorb wieder her.
   - Alle Links zum Starterkit-/Startbonus-Rechner (Hauptmenue
     "Neukund:innen", Startseiten-Karte, Suche) fuehren zum Dental-
     Rechner, damit man im "Dental-Kosmos" bleibt. Ausnahme: Links mit
     dt_id (Partnerlinks). Das Untermenue regelt das selbst in Liquid
     (sections/subnav-neukunden.liquid).

   POS-Material gibt es fuer Dental-Praxen NICHT (Entscheidung Sales
   29.09.2026). Im Dental-Modus:
   - die Rechner (Dental, Starterkit, Startbonus) zeigen keinen
     POS-Block und legen kein POS-Paket in den Warenkorb
   - POS-Pakete werden aus dem Warenkorb entfernt (Sicherheitsnetz)
   - Zubehoer-Kacheln, Suchtreffer und das Warenkorb-Formular der
     POS-Produktseiten blendet layout/theme.liquid per CSS aus
   Dieser Teil haengt nur am Dental-Modus, nicht am Stichtag.
   Ausserhalb des Dental-Modus, im Aposanitas-Modus und nach dem
   Stichtag wird STARTERKITDENTAL wieder entfernt.

   Stichtag steht an DREI Stellen und muss zusammenpassen:
   1. hier (cutoff, erster Tag OHNE Aktion)
   2. templates/page.dental.json -> "Eigener Stichtag" 2026-10-16
   3. Shopify-Rabatt DENTALSTARTERKIT20 (endet 15.10.2026 23:59)

   Nach dem 15.10. tut die Datei nichts mehr. Aufraeumen optional.
   ============================================================ */
window.gcDental = Object.assign({
  code: 'DENTALSTARTERKIT20',
  legacyCodes: ['STARTERKITDENTAL'],
  replaces: 'STARTERKIT2026',
  foreignPartnerCodes: ['VITAMINDENTAL'],
  cutoff: '2026-10-16T00:00:00+02:00',
  pagePath: '/pages/dental',
  posHandles: ['pos-basis-paket', 'pos-premium-paket']   /* auch in layout/theme.liquid */
}, window.gcDental || {});

function gcDentalActive(){
  return new Date() < new Date(window.gcDental.cutoff);
}

/* Dental-Modus beenden (Warenkorb-Attribute loeschen). */
async function gcDentalReset(){
  try{
    const root = window.Shopify.routes.root;
    await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ attributes: { dental_flow: '', Kundengruppe: '' } })
    });
  } catch(err){
    console.error('Dental-Reset fehlgeschlagen:', err);
  }
}

async function gcEnforceDental(){
  try{
    const C = window.gcDental;
    const root = window.Shopify.routes.root;
    const res = await fetch(root + 'cart.js');
    const cart = await res.json();
    const attrs = cart.attributes || {};
    const current = (cart.discount_codes || []).map(d => d.code);
    const up = c => (c || '').toUpperCase();

    let deviceQty = 0, boxQty = 0;
    cart.items.forEach(i => {
      if(i.product_type === 'Geraet') deviceQty += i.quantity;
      if(i.product_type === 'Testkit') boxQty += i.quantity;
    });

    const minBoxes = (typeof gcDiscountThresholds === 'function')
      ? gcDiscountThresholds().starterkitMinBoxes
      : 5;

    /* Leerer Warenkorb = Dental-Modus vorbei (ausser auf der Dental-Seite
       selbst, dort wird er ja gerade erst gesetzt). */
    const here = (window.location.pathname || '').replace(/\/+$/, '');
    if(attrs.dental_flow === 'true' && cart.item_count === 0 && here !== C.pagePath){
      await gcDentalReset();
      return;
    }

    const dentalMode = attrs.dental_flow === 'true' && attrs.aposanitas_flow !== 'true';
    const isDental = dentalMode && gcDentalActive();

    /* POS-Material raus (gilt im Dental-Modus unabhaengig vom Stichtag) */
    const posUpdates = {};
    if(dentalMode){
      cart.items.forEach(i => {
        if(C.posHandles.indexOf(i.handle) !== -1) posUpdates[i.variant_id] = 0;
      });
    }

    const eligible = isDental && deviceQty >= 1 && boxQty >= minBoxes;

    const own = [C.code].concat(C.legacyCodes || []);
    let desired = current.filter(c => own.indexOf(up(c)) === -1);
    if(dentalMode){
      desired = desired.filter(c => (C.foreignPartnerCodes || []).indexOf(up(c)) === -1);
    }
    if(eligible){
      desired = desired.filter(c => up(c) !== C.replaces);
      desired.unshift(C.code);
    }

    const body = {};
    const same = desired.length === current.length && desired.every(c => current.indexOf(c) !== -1);
    if(!same) body.discount = desired.join(',');
    const attrUpd = {};
    if(eligible && attrs.startbonus_flow) attrUpd.startbonus_flow = '';
    if(dentalMode && /vitamin dental/i.test(attrs.Partner || '')) attrUpd.Partner = '';
    if(Object.keys(attrUpd).length) body.attributes = attrUpd;
    if(Object.keys(posUpdates).length) body.updates = posUpdates;
    if(!Object.keys(body).length) return;

    await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    });
    if(typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
  } catch(err){
    console.error('Dental-Check fehlgeschlagen:', err);
  }
}

(function(){
  const orig = window.gcEnforceMengenrabatt;
  window.gcEnforceMengenrabatt = async function(){
    if(typeof orig === 'function') await orig.apply(this, arguments);
    await gcEnforceDental();
  };

  /* "Warenkorb leeren" (assets/gc-cart-clear.js) ruft die Automatik
     nicht auf - deshalb hier drumlegen. Der Rueckgaengig-Speicher
     sichert die Attribute VOR dem Leeren, stellt dental_flow also mit
     wieder her. */
  const origClear = window.gcClearCart;
  if(typeof origClear === 'function'){
    window.gcClearCart = async function(){
      await origClear.apply(this, arguments);
      try{
        const res = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await res.json();
        if(cart.item_count === 0 && (cart.attributes || {}).dental_flow === 'true') await gcDentalReset();
      } catch(e){}
    };
  }
})();

(function(){
  const C = window.gcDental;
  if(!gcDentalActive()) return;
  const path = (window.location.pathname || '').replace(/\/+$/, '');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Aufruf der Dental-Seite: Warenkorb als Dental markieren. Das
     Attribut "Kundengruppe" steht spaeter an der Bestellung im Admin. */
  if(path === C.pagePath){
    fetch(root + 'cart.js')
      .then(r => r.json())
      .then(cart => {
        const attrs = cart.attributes || {};
        if(attrs.dental_flow === 'true') return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ attributes: { dental_flow: 'true', Kundengruppe: 'Dental' } })
        }).then(() => {
          if(cart.item_count > 0 && typeof window.gcEnforceMengenrabatt === 'function'){
            return window.gcEnforceMengenrabatt();
          }
        });
      })
      .catch(err => console.error('Dental-Markierung fehlgeschlagen:', err));
    return;
  }

})();

/* Rechner im Dental-Modus (und auf der Dental-Seite schon beim ersten
   Aufruf): POS-Block ausblenden und "Kein POS-Material" waehlen, damit
   der Rechner kein Paket in den Warenkorb legt. Das CSS in
   layout/theme.liquid versteckt die Optionen schon vor dem ersten
   Zeichnen; hier kommen Ueberschrift, Hinweistext und Trennlinie dazu. */
(function(){
  const ctx = window.gcCartContext || {};
  const onDentalPage = document.body.classList.contains('gc-page-dental');
  if(!ctx.dentalMode && !onDentalPage) return;
  document.querySelectorAll('.pos-options').forEach(function(opts){
    const none = opts.querySelector('input[type="radio"][value="none"]');
    if(none){
      none.checked = true;
      none.dispatchEvent(new Event('change', { bubbles: true }));
    }
    let el = opts.previousElementSibling;
    while(el && !el.classList.contains('divider')){
      if(el.tagName !== 'STYLE') el.style.display = 'none';
      el = el.previousElementSibling;
    }
    const after = opts.nextElementSibling;
    if(after && after.classList.contains('divider')) after.style.display = 'none';
  });
})();

/* Dental-Kosmos: Links zum normalen Starterkit-/Startbonus-Rechner
   zeigen im Dental-Modus auf den Dental-Rechner (nur solange die Aktion
   laeuft). Keine Umleitung - wer die normale Seite direkt aufruft,
   sieht sie auch. */
(function(){
  if(!gcDentalActive()) return;
  const ctx = window.gcCartContext || {};
  const onDentalPage = document.body.classList.contains('gc-page-dental');
  if(!ctx.dentalMode && !onDentalPage) return;
  const target = window.gcDental.pagePath;
  const from = ['/pages/igloo-starterkit', '/pages/igloo-startbonus'];

  document.querySelectorAll('a[href]').forEach(function(a){
    let u;
    try{ u = new URL(a.getAttribute('href'), window.location.origin); } catch(e){ return; }
    if(u.origin !== window.location.origin) return;
    if(from.indexOf(u.pathname.replace(/\/+$/, '')) === -1) return;
    if(u.searchParams.has('dt_id')) return;
    a.setAttribute('href', target + u.search);
  });

  /* "Rechner"-Treffer in der Live-Suche (theme.js) */
  try{
    if(typeof GC_CUSTOM_SEARCH_ENTRIES !== 'undefined'){
      GC_CUSTOM_SEARCH_ENTRIES.forEach(function(e){
        if(from.indexOf(e.url) !== -1){ e.url = target; e.title = 'Starterkit-Rechner'; }
      });
    }
  } catch(e){}

  /* Hauptmenue: "Neukund:innen" auf der Dental-Seite hervorheben */
  if(onDentalPage){
    const nav = document.getElementById('nav-neukunden');
    if(nav) nav.classList.add('active');
  }
})();

/* POS-Produktseite im Dental-Modus: Formular ist per CSS ausgeblendet
   (layout/theme.liquid), hier kommt der Hinweis dazu. */
(function(){
  const ctx = window.gcCartContext || {};
  if(!ctx.dentalMode) return;
  if(!document.body.classList.contains('gc-pos-product')) return;
  const info = document.querySelector('.product-info');
  if(!info) return;
  const p = document.createElement('p');
  p.className = 'gc-beigabe-note';
  p.textContent = 'POS-Material ist für Dental-Praxen nicht erhältlich.';
  info.appendChild(p);
})();
